<template>
    <div id="modelViewsShare" class="modelViewsShare">
        <el-dialog
            v-if="modelViewsStatus"
            custom-class="modelViewsShareDialog"
            :title="title"
            :visible.sync="modelViewsStatus"
            :append-to-body="true"
            :close-on-click-modal="false"
            :before-close="closeModelViewsDialog"
            width="25%"
        >
            <!-- 文件信息 -->
            <div class="file-info">
                <div class="top-title">文件名称</div>
                <div class="file-name">{{ fileName }}</div>
            </div>
            <div class="share-form-container">
                <el-form label-position="left">
                    <el-form-item label="视图名称:" v-if="viewName && modelType === 0">
                        <span class="content-ctx">{{ viewName }}</span>
                    </el-form-item>
                    <el-form-item label="加载方式:">
                        <el-radio-group v-model="convertType" class="radio-group">
                            <el-radio :label="0" :disabled="isDisabled.obv">全量</el-radio>
                            <el-radio :label="1" :disabled="isDisabled.lod">流式</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="访问权限:" v-if="false">
                        <el-radio-group v-model="sharePermissions" class="radio-group">
                            <el-radio :label="0">查看</el-radio>
                            <el-radio :label="1">下载</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="分享形式:">
                        <el-radio-group v-model="shareType" class="radio-group">
                            <el-radio :label="0">公开</el-radio>
                            <el-radio :label="1">加密</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="有效期:">
                        <el-select class="time-select" v-model="shareTime" placeholder="请选择">
                            <el-option
                                v-for="item in timeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="content-container">
                <div v-show="shareURL !== ''" class="shareURL-group">
                    <span class="content-title">分享地址：</span>
                    <el-input v-model="shareURL" class="newInput">
                        <el-button slot="append" @click.prevent="copyUrl" style="background-color: #0c78e2"
                            ><i class="fa fa-copy"></i> 地址复制</el-button
                        >
                    </el-input>
                    <el-input v-if="shareCode !== null" v-model="shareCode">
                        <el-button
                            slot="append"
                            @click.prevent="copyCode"
                            class="btn share-btn"
                            style="margin-right: 1px"
                            ><i class="fa fa-copy"></i> 密码复制</el-button
                        >
                        <el-button slot="append" @click.prevent="submitSave" class="btn share-btn"
                            ><i class="fa fa-copy"></i> 保存本地</el-button
                        >
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button :disabled="shareAble" class="btn share-btn" @click.prevent="shareFiles">分享</button>
                <button class="btn cancel-btn" @click.prevent="closeModelViewsDialog">取消</button>
            </span>
        </el-dialog>
        <contactUsCom @send-message="sendMessage" ref="contactUsCom"></contactUsCom>
    </div>
</template>
<script>
import { shareFile } from 'src/utils/shareUtils';
import { sendEmailToAccountUpgrade } from 'src/utils/sendMessage';
import contactUsCom from 'src/pages/devCenter/consoleLab/components/contactUsCom';
import { getModelAssembleView } from 'src/utils/modelAssemble';

export default {
    name: 'modelViewsShare',
    components: {
        contactUsCom,
    },
    props: {
        allJobType: Object,
        isDownload: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            shareAble: false, // 分享按钮置灰
            downLoadStatus: false, // 是否已经下载了
            modelViewsStatus: false,
            currentUrn: '',
            title: '模型分享',
            fileName: '',
            viewName: '',
            shareURL: '',
            shareCode: null,
            guid: '',
            modelType: null,
            modelViewsData: [],
            modelViewsOptions: [],
            tokenData: '', // 浏览用的token
            activeView: '',
            convertType: 0, // 加载方式
            shareType: 0, // 分享形式
            sharePermissions: 0, //访问权限
            packageId: '',
            shareTime: 1, //过期时间
            timeOptions: [
                {
                    value: 1,
                    label: '1天',
                },
                {
                    value: 7,
                    label: '7天',
                },
                {
                    value: 30,
                    label: '30天',
                },
                {
                    value: -1,
                    label: '永久',
                },
            ],
            isDisabled: {
                obv: false,
                lod: false,
            },
        };
    },
    mounted() {},
    methods: {
        Open(fileInfo, viewModel) {
            // 表单数据重置
            this.convertType = 0;
            this.shareType = 0;
            this.sharePermissions = 0;
            // 判断已完成转换的类型，需要禁用的选项
            this.isDisabled = {
                obv: true,
                lod: true,
            };
            if (fileInfo.objectStatus) {
                if (fileInfo.objectStatus.lod && fileInfo.objectStatus.lod === '完成转换') {
                    this.isDisabled.lod = false;
                    this.convertType = 1;
                    if (viewModel.role && viewModel.role !== '3d') {
                        this.isDisabled.lod = true;
                        this.convertType = 0;
                    }
                }
                if (fileInfo.objectStatus.obv && fileInfo.objectStatus.obv === '完成转换') {
                    this.isDisabled.obv = false;
                    this.convertType = 0;
                }
            }
            // 清空数据
            this.modelViewsOptions = [];
            this.shareURL = '';
            this.shareCode = null;
            const { fileName, urn } = fileInfo;
            const { name, guid } = viewModel;
            this.currentUrn = urn;
            this.viewName = name;
            this.fileName = fileName;
            this.modelType = viewModel.type;
            this.packageId = viewModel.packageId;
            this.guid = guid;
            this.modelViewsStatus = true;
            // 模型组装信息查询
            if (this.packageId) {
                getModelAssembleView(this.packageId).then((model) => {
                    model.forEach((item) => {
                        this.modelViewsOptions.push({
                            documentUrn: item.urn,
                            guid: item.guid,
                            offset: { x: item.x, y: item.y, z: item.z, r: item.r },
                        });
                    });
                });
            }
        },
        closeModelViewsDialog() {
            if (this.shareCode !== null && this.shareType === 1 && this.downLoadStatus === false) {
                this.$confirm('您还未保存分享密码的相关信息，确认关闭？')
                    .then((res) => {
                        this.shareAble = false;
                        this.modelViewsData = [];
                        this.modelViewsStatus = false;
                    })
                    .catch((err) => {});
            } else {
                this.shareAble = false;
                this.modelViewsData = [];
                this.modelViewsStatus = false;
            }
        },
        shareFiles() {
            let _self = this;
            this.shareAble = true;
            let isViewShare = this.modelType === 0;
            let isAssembleShare = this.modelType === 2 || this.modelType === 5;
            const tempConf = isAssembleShare
                ? { modelViewsOptions: this.modelViewsOptions }
                : isViewShare
                ? { viewName: this.viewName, guid: this.guid }
                : '';
            let conf = JSON.stringify(tempConf);
            let data = {
                name: `${this.fileName}`,
                urn: `${this.currentUrn}`,
                type: this.modelType,
                isOpen: this.shareType,
                mode: this.convertType,
                isView: this.sharePermissions,
                expiration: this.shareTime,
                conf: conf,
            };
            shareFile(data)
                .then((res) => {
                    _self.shareURL = `${window.location.origin}/devcenter/shareView/${res.data.id}`;
                    _self.shareCode = res.data.password;
                    _self.$message.success('分享成功！');
                })
                .catch((err) => {
                    let errStr = err.responseJSON.message;
                    _self.errMessage(errStr);
                });
        },
        copyUrl() {
            this.$copyText(this.shareURL).then(
                (res) => {
                    this.$message.success('复制成功');
                },
                (err) => {
                    this.$message.error('复制失败');
                },
            );
        },
        copyCode() {
            this.$copyText(this.shareCode).then(
                (res) => {
                    this.$message.success('复制成功');
                },
                (err) => {
                    this.$message.error('复制失败');
                },
            );
        },
        // subStingError(str) {
        //     let begin = str.indexOf('<message>') + 9;
        //     let end = str.indexOf('</message>');
        //     return str.substring(begin, end);
        // },
        submitSave() {
            this.downLoadStatus = true;
            const element = document.createElement('a');
            // 文件的名称
            element.download = this.fileName + 'Password.txt';
            element.style.display = 'none';
            const appCredentials = `modelShareURL:${this.shareURL}\nmodelShareSecret: ${this.shareCode}`;
            let tips = '\n注意： 请妥善保管分享文件密码,一但遗失,请联系管理员重新获取。';
            tips += '\nEmail：cloud@pkpm.com.cn';
            tips += '\n 189-1614-5929（微信同号） 吴经理';
            const blob = new Blob([appCredentials + tips]);
            element.href = URL.createObjectURL(blob);
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        errMessage(errText) {
            this.$refs.contactUsCom.Open(errText);
        },
        sendMessage(text) {
            if (!text) {
                this.$message.warning('联系内容不为空！');
                return;
            }
            // todo 后台接口限制 每10分钟 才能发一次
            sendEmailToAccountUpgrade(text)
                .then(() => {
                    this.$refs.contactUsCom.close();
                    this.$message.success('发送邮件成功！');
                })
                .catch((e) => {
                    let error = '';
                    if (e && e.responseText.indexOf('请求太频繁了，休息一会吧。') !== -1) {
                        error = '请求太频繁了，休息一会吧。';
                    }
                    this.$message.error(`发送失败！请重试${error}`);
                });
        },
    },
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.file-info
  margin-bottom 10px
  .top-title
    margin-bottom 10px
  .file-name
    border 1px solid #ccc
    padding 5px 12px
    line-height 32px
    -webkit-user-select text
.share-form-container
  .time-select
    width 30%
    margin 0px
.content-container
  display flex
  flex-direction column
  .content-title
    margin-bottom 15px
    font-size 16px
    font-weight bold
  .content-ctx
    margin-bottom 20px
    font-size 16px
  .shareURL-group
    display flex
    flex-direction column
    margin-top 20px
    >>> .el-input
      padding-top 10px
    >>> .el-input__inner
      /* border-radius 20px 20px 20px 20px */
    >>> .el-input-group__append
      color rgba(255, 255, 255, 1)
      border 1px solid white
      /* background-color: #0C78E2 */
.newInput
  >>> .el-input__inner
    border-radius 20px 0px 0px 20px
.btn
  width 100px
  height 40px
  margin-left 10px
  border-radius 20px
  border 0px
  outline none
  &:hover
    color #ffffff
.btn.share-btn
  background-color #0C78E2
.btn.cancel-btn
  color #303133
  border 1px solid #909399
</style>
<style lang="stylus" rel="stylesheet/stylus">
.modelViewsShareDialog
  .el-dialog__header
    border-bottom 1px solid #eee
    .el-dialog__title
      color #333
  .el-dialog__body
    padding-top 10px
    padding-bottom 10px
    .el-form-item
      margin-bottom 5px
      .el-form-item__label
        font-weight bold
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/modelViews-share.vue